import KakaoBankImg1 from '@/assets/img/corporate-and-organization/kakaobank_img01@2x.jpg';
import KakaoBankImg2 from '@/assets/img/corporate-and-organization/kakaobank_img02@2x.jpg';
import KakaoBankLogo from '@/assets/img/corporate-and-organization/kakaobank_logo@2x.png';
import KakaoBankLogoM from '@/assets/img/corporate-and-organization/kakaobank_logo_m@2x.png';
import Button from '@/components/Button';
import Container from '@/components/Container';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { navigate, PageProps } from 'gatsby';

import React from 'react';
import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
`;
const ImgBox = styled.div`
  position: relative;
  width: 100%;

  .img_copyright {
    font-size: 12px;
    color: #fff;
    opacity: 0.5;
    position: absolute;
    bottom: 23px;
    left: 20px;
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);

    ${breakpoint(`mobile`)} {
      bottom: 13px;
      left: 10px;
    }
  }
`;
const SectionHead = styled.section`
  background: #f8fcfe;
  padding: 96px 0 120px;

  ${breakpoint(`mobile`)} {
    padding: 72px 0 44px;

    .br_pc {
      display: none;
    }
  }

  ${Flex} {
    align-items: flex-end;
    gap: 60px;

    ${breakpoint(`tablet`)} {
      flex-direction: column;
    }
    ${breakpoint(`mobile`)} {
      gap: 32px;
    }
  }

  ${ImgBox} {
    width: 57%;
    ${breakpoint(`tablet`)} {
      width: 100%;
    }
  }

  .company_info {
    ${breakpoint(`tablet`)} {
      width: 100%;
    }
    .company_logo img {
      width: auto;
    }

    .company_name {
      font-size: 40px;
      font-weight: 700;
      margin: 30px 0 40px;
    }

    ul {
      border-top: 1px solid #2d2926;
      padding-top: 20px;

      li {
        display: flex;
        align-items: center;
        position: relative;

        & + li {
          margin-top: 6px;
        }

        &::before {
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          border-radius: 100%;
          background: #1cabe2;
          position: absolute;
          top: 11px;
          left: 0;
          flex-shrink: 0;
        }

        .info_tit {
          font-weight: 700;
          color: #1cabe2;
          width: 102px;
          flex-shrink: 0;
          margin-right: 45px;
          padding-left: 12px;
        }
      }
    }
    ${breakpoint(`mobile`)} {
      .company_name {
        font-size: 24px;
        margin: 12px 0 20px;
      }

      ul {
        li {
          line-height: 28px;
          & + li {
            margin-top: 4px;
          }

          .info_tit {
            width: 92px;
            margin-right: 30px;
          }
        }
      }
    }
  }
`;
const SectionBody = styled.section`
  padding-top: 120px;
  p {
    margin-top: 32px;
    line-height: 32px;
  }

  ${breakpoint(`mobile`)} {
    padding-top: 60px;

    .br_pc {
      display: none;
    }
    p {
      font-size: 14px;
      line-height: 28px;
    }
  }

  ${Container} {
    & + ${Container} {
      margin-top: 96px;

      ${breakpoint(`mobile`)} {
        margin-top: 72px;
      }
    }
  }

  ${Flex} {
    margin-top: 32px;

    ${breakpoint(`tablet`)} {
      flex-direction: column;
    }

    ${ImgBox} {
      width: 444px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      ${breakpoint(`tablet`)} {
        width: 100%;
        flex-shrink: 1;
      }
    }
    .list_box {
      width: calc(100% - 444px);
      background: #edf7fa;
      padding: 47px 40px;

      ${breakpoint(`tablet`)} {
        width: 100%;
      }
      ${breakpoint(`mobile`)} {
        padding: 32px 24px;
      }

      ul {
        margin-top: 10px;
        li {
          position: relative;
          padding-left: 18px;
          line-height: 32px;

          &::before {
            content: '';
            display: block;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background: #1cabe2;
            position: absolute;
            top: 14px;
            left: 0;
          }
          ${breakpoint(`mobile`)} {
            font-size: 14px;
            line-height: 28px;

            &::before {
              top: 13px;
            }
          }
        }
      }
    }
  }

  .video_wrap {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
    margin-top: 32px;

    .video {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  .btn_wrap {
    margin-top: 64px;
    text-align: center;

    ${breakpoint(`mobile`)} {
      margin-top: 48px;
    }
    ${Button} {
      font-size: 16px;
    }
  }
`;

const KaokaoBank: React.FC<PageProps> = ({ location }) => (
  <LayoutWithTitle
    location={location}
    title="기업·기관 사회공헌"
    description="for every child, partnerships"
  >
    <SectionHead>
      <Container>
        <Flex>
          <ImgBox>
            <img
              src={KakaoBankImg1}
              alt="유니세프 X 카카오뱅크 글로벌 기후위기에 노출된 미래세대 지원을 위한 사회공헌 협약 이미지"
            />
            <div className="img_copyright">© 유니세프 한국위원회</div>
          </ImgBox>
          <div className="company_info">
            <div className="company_logo">
              <Image
                pcSrc={KakaoBankLogo}
                mobileSrc={KakaoBankLogoM}
                alt="Kakaobank 로고"
              />
            </div>
            <div className="company_name">카카오뱅크</div>
            <ul>
              <li>
                <div className="info_tit">산업군</div>
                <div className="info_con">금융</div>
              </li>
              <li>
                <div className="info_tit">파트너십 레벨</div>
                <div className="info_con">Global&National</div>
              </li>
              <li>
                <div className="info_tit">홈페이지</div>
                <div className="info_con">
                  <LinkSafe to="https://www.kakaobank.com/" target="_blank">
                    https://www.kakaobank.com/
                  </LinkSafe>
                </div>
              </li>
              <li>
                <div className="info_tit">지원 분야​</div>
                <div className="info_con">Climate Change</div>
              </li>
            </ul>
          </div>
        </Flex>
      </Container>
    </SectionHead>
    <SectionBody>
      <Container>
        <Tit size="s1-5">카카오뱅크는</Tit>
        <p>
          현재 전 세계 <strong>2억 4,200만명</strong>의 어린이들은 폭염, 폭우,
          홍수, 가뭄 등 극심한 기후 현상으로 제대로 된 교육을 받지 못하고 있는
          상황입니다. <br /> 또한 유니세프는 ‘세계 어린이 현황’ 보고서를 통해
          2050년에서 2059년 사이에는 기후위기 위험에 노출될 어린이가 2000년대
          대비 <strong>8배</strong> 가량 증가할 것으로 예상하고 있습니다. <br />
          기후변화 문제 해결을 위해 그리고 기후변화의 영향을 받는 전 세계 아동을
          지원하기 위해 2024년부터 유니세프와 함께 카카오뱅크 프로젝트를
          진행하고 있습니다. <br /> 2024년 한 해에만 13억원의 기금을
          후원하였으며 카카오뱅크와 유니세프가 공동으로 주최하는 친환경 기부
          마라톤 ‘Save Race’를 통해 행사 참가비 전액을 추가로 후원하였습니다.{' '}
          <br /> 카카오뱅크와 유니세프의 파트너십 및 후원사업은 유니세프
          동아시아 태평양 지역사무소와(UNICEF EAPRO) 함께 진행되며, 유니세프
          기업 파트너십 후원사업 중 <br className="br_pc" />{' '}
          <strong>아시아 지역 최대 규모</strong>로 진행되고 있습니다. 유니세프는
          전 세계 190여개 국가에 위치한 국가사무소 및 지역사무소 그리고 글로벌
          네트워킹을 통해, 파트너사가 진행하는 <br className="br_pc" />
          후원사업의 범위와 영향력을 전 <strong>세계적으로 확대</strong>할 수
          있도록 노력합니다.
        </p>
      </Container>
      <Container>
        <Tit size="s1-5">카카오뱅크의 후원금으로</Tit>
        <p>
          24년(사업 1차년도)에는 동남아시아 5개국(캄보디아, 라오스, 말레이시아,
          태국, 미얀마)에서 환경, 교육, 보건 등 다양한 분야에서의 기후변화
          사업이 진행되었습니다.
        </p>
        <Flex>
          <ImgBox>
            <img
              src={KakaoBankImg2}
              alt="어린이가 바가지로 머리에 물을 붓고 있는 모습"
            />
            <div className="img_copyright">
              © UNICEF/Cambodia/2019/Fani Llauurado
            </div>
          </ImgBox>
          <div className="list_box">
            <strong>주요 진행 사업</strong>
            <ul>
              <li>
                의료 및 교육시설(학교) 내 태양광 발전 설비 도입 사업(캄보디아)
              </li>
              <li>디지털 보건시스템 구축 사업(캄보디아)</li>
              <li>친환경 학교 환경 조성 구축 사업(라오스)</li>
              <li>지역별 기후위기 현황 조사 및 데이터 분석 사업(태국)</li>
              <li>기후재난 위험 감소 사업(태국)</li>
            </ul>
          </div>
        </Flex>
      </Container>
      <Container>
        <Tit size="s1-5">
          카카오뱅크와 유니세프가 함께하는 친환경 기부 마라톤, ‘Save Race’
        </Tit>
        <div className="video_wrap">
          <iframe
            className="video"
            src="https://www.youtube.com/embed/nheQP0Dg4F4"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <p>
          카카오뱅크와 유니세프는 기후위기 피해 어린이를 지원하기 위해 24년
          11월, 첫 친환경 기부 마라톤 행사를 개최하였습니다. <br />
          Save Race의 참가비 전액 역시 동아시아 지역 기후위기 피해 어린이를 위해
          후원 되었으며, <br className="br_pc" /> 참가자 분들의 발자국은
          동아시아 지역 기후위기 극복을 위한 소중한 발걸음이 되었습니다.
        </p>
      </Container>
      <div className="btn_wrap">
        <Button
          className="btn"
          color="grey"
          width={256}
          onClick={() =>
            navigate(`/involve/corporate-and-organization/social-contribution`)
          }
        >
          뒤로가기
        </Button>
      </div>
    </SectionBody>
  </LayoutWithTitle>
);

export default KaokaoBank;
